import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "users-table--cell" }
const _hoisted_2 = {
  key: 0,
  class: "uis uis-padlock text-[16px] mr-2 text-Text/text_medium flex items-center"
}

import { User_Status } from '@/graphql/codegen/generated/graphql';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserStatusCell',
  props: {
    status: null
  },
  setup(__props: any) {

const props = __props as {
  status: User_Status;
}


const isUserActive = computed(() => props.status === User_Status.Active);
const isUserLocked = computed(() => props.status === User_Status.Locked);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["users-table--cell-content flex items-center", { 'user-locked': _unref(isUserLocked) }])
    }, [
      (_unref(isUserLocked))
        ? (_openBlock(), _createElementBlock("i", _hoisted_2))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass([_unref(isUserActive) ? 'bg-System/app_primary' : 'bg-System/app_grey_76', "w-2 h-2 rounded-[50%] mr-2"])
          }, null, 2)),
      _createElementVNode("span", null, _toDisplayString(__props.status), 1)
    ], 2)
  ]))
}
}

})